import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from 'redux/store';
import MaintenanceOverlay from 'components/MaintenanceOverlay';

// Set Outseta plan UID in meta tag for HTML script to access
const planUidMeta = document.getElementById('outseta-plan-uid-2-meta');
if (planUidMeta && process.env.REACT_APP_OUTSETA_PLAN_UID_2) {
	planUidMeta.setAttribute('content', process.env.REACT_APP_OUTSETA_PLAN_UID_2);
}
// Also set in window for fallback
if (process.env.REACT_APP_OUTSETA_PLAN_UID_2) {
	(window as any).REACT_APP_OUTSETA_PLAN_UID_2 = process.env.REACT_APP_OUTSETA_PLAN_UID_2;
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
const isMaintenanceMode =
	process.env.REACT_APP_MAINTENANCE_MODE === 'true' &&
	!sessionStorage.getItem('cap_bypass_maintenance');


root.render(
	// <React.StrictMode>
	<Provider store={store}>
			{isMaintenanceMode ? <MaintenanceOverlay /> : <App />}
	</Provider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
